import { Component } from '@angular/core';
import { RouterLink } from '@angular/router'
@Component({
  selector: 'app-copy-text-from-pdf',
  imports: [RouterLink],
  templateUrl: './copy-text-from-pdf.component.html',
  styleUrl: './copy-text-from-pdf.component.css'
})
export class CopyTextFromPdfComponent {

}
